import Icon from 'ui/atoms/icon';
import styled, { css, ExecutionContext } from 'styled-components';
import { query } from 'ui/styles/queries';
import Spacing from 'src/ui/types/spacing';
import Size from 'src/ui/types/size';

interface FormGroupContainerProps {
  $hasTooltip: boolean;
  $occupyTooltipSpace: boolean;
  $displayBlock?: boolean;
}

interface FormGroupLabelProps {
  $spacing: Spacing;
  $size?: Size;
}

function getSpacing({ theme, $spacing }: ExecutionContext & FormGroupLabelProps) {
  return css`
    margin-bottom: ${theme.spacing[$spacing]}rem;
  `;
}

function getSize({ theme, $size }: ExecutionContext & FormGroupLabelProps) {
  return css`
    ${$size === 'small' &&
    css`
      font-size: 0.875rem;
    `}

    ${query.phone`
      font-size: ${$size === 'small' ? '0.75rem' : '0.875rem'};
    `};
  `;
}

export const FormGroupLabel = styled.label<FormGroupLabelProps>`
  display: flex;
  align-items: center;
  ${getSpacing}
  ${getSize}
`;

export const FormGroupRequirements = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RequirementsInfo = styled.div`
  display: flex;
`;

export const SameRow = styled.div`
  display: flex;
  justify-content: space-between;

  ${query.phone`
    font-size: 0.875rem;
  `};
`;

export const GroupedElements = styled.div`
  display: flex;
`;

export const RequirementInfoIcon = styled(Icon)`
  height: fit-content;
  margin-top: 0.25rem;
`;

function getDisplay({ $hasTooltip, $occupyTooltipSpace, $displayBlock }: ExecutionContext & FormGroupContainerProps) {
  if ($occupyTooltipSpace) {
    return css`
      margin-right: 2rem;
    `;
  }

  if ($hasTooltip && !$displayBlock) {
    return css`
      display: flex;
      align-items: center;
    `;
  }

  return css`
    display: contents;
    width: 100%;
  `;
}

export const FormGroupContainer = styled.div<FormGroupContainerProps>`
  ${getDisplay}
`;
